/* *************************************************************** *
 * THIS IS AN AUTO GENERATED FILE. PLEASE DO NOT EDIT IT DIRECTLY.
 *
 * If you want to change this Icon component , it is generated
 * from the `iconTamplate.js` file the parent directory.
 * *************************************************************** */
/* eslint-disable */
import React from 'react';
import { useFela, } from 'react-fela';
import iconStyle from '../iconStyle';
import { iconPropTypes, iconDefaultProps, } from '../iconPropTypes';

export default function IconFacebookLogo({ size, fill, color, attrs, miscStyles, ...props }) {
  const className = useFela({ size, fill, color, miscStyles, }).css(iconStyle);

  return (
    <svg width="1em" height="1em" viewBox="0 0 16 16" className={className} {...props} {...attrs} data-test="IconFacebookLogo" ><path fill="currentColor" d="M14 8.036a6 6 0 1 0-12 0 6.001 6.001 0 0 0 5.062 5.927V9.771H5.539V8.036h1.523V6.715c0-1.504.896-2.334 2.266-2.334.656 0 1.343.117 1.343.117v1.477h-.756c-.745 0-.978.463-.978.937v1.126h1.664l-.266 1.734H8.938v4.193A6.005 6.005 0 0 0 14 8.036z"/></svg>
  );
}

IconFacebookLogo.propTypes = iconPropTypes;
IconFacebookLogo.defaultProps = iconDefaultProps;
